module.exports = __webpack_public_path__ + "static/media/FIFA.fc3b4ad1.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/Dashboard/Partners/images/FIFA.png
// module id = 2541
// module chunks = 1